import {
  primaryColor,
  dangerColor,
  successColor,
  defaultFont,
  whiteColor,
  grayColor,
  primaryDarkBlueColor,
} from "../../material-dashboard-pro-react.jsx";

const radius = 15;
const fieldBg = "#F7F9FC";
const fieldBor = grayColor[4];
const BRAND = "#1a3768"; // colors.mcsdark
const softShad = "0 1px 2px rgba(0,0,0,.08)";

const customInputStyle = {
  disabled: {
    "&:before": {
      borderColor: "transparent !important",
    },
  },
  underline: {
    "&:hover:not($disabled):before,&:before": {
      borderColor: grayColor[4] + "!important",
      borderWidth: "1px !important",
      borderRadius: "15px",
    },
    "&:after": {
      borderColor: primaryColor[0],
    },
  },
  underlineError: {
    "&:after": {
      borderColor: dangerColor[0],
    },
  },
  underlineSuccess: {
    "&:after": {
      borderColor: successColor[0],
    },
  },
  labelRoot: {
    ...defaultFont,
    color: grayColor[3] + " !important",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "1.42857",
    top: "10px",
    "& + $underline": {
      marginTop: "0px",
    },
  },
  labelRootError: {
    color: dangerColor[0] + " !important",
  },
  labelRootSuccess: {
    color: successColor[0] + " !important",
  },
  formControl: {
    margin: "4px 0 10px 0",
    // paddingTop: "27px",
    position: "relative",
    verticalAlign: "unset",
    "& svg,& .fab,& .far,& .fal,& .fas,& .material-icons": {
      color: grayColor[14],
    },
  },
  whiteUnderline: {
    "&:hover:not($disabled):before,&:before": {
      backgroundColor: whiteColor,
    },
    "&:after": {
      backgroundColor: whiteColor,
    },
  },
  input: {
    color: grayColor[14],
    borderRadius: "15px",
    backgroundColor: "#f8f9fb", // <— subtle light gray background
    "&,&::placeholder": {
      fontSize: "14px",
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: "400",
      lineHeight: "1.42857",
      opacity: "1",
      boxShadow: "0 1px 2px 0 grey",
    },
    "&::placeholder": {
      color: grayColor[3],
    },
  },

  outlinedRoot: {
    borderRadius: radius,
    backgroundColor: fieldBg,
    boxShadow: softShad,
    // default outline
    "& $outlinedNotchedOutline": {
      borderRadius: radius,
      borderColor: grayColor[4],
    },
    // hover outline color
    "&:hover $outlinedNotchedOutline": {
      borderColor: BRAND + " !important",
    },
    // focused outline color
    "&$outlinedFocused $outlinedNotchedOutline": {
      borderColor: BRAND + " !important",
      borderWidth: "2px",
    },
    // remove UA focus ring inside
    "& input:focus": { outline: "none" },
  },

  outlinedNotchedOutline: {},
  outlinedFocused: {},

  notchedOutline: {
    borderRadius: `${radius}px`, // the fieldset element
  },

  inputMultiline: {
    padding: "10px 14px",
    lineHeight: "1.5",
  },

  "@global": {
    "input:-webkit-autofill, textarea:-webkit-autofill, select:-webkit-autofill":
      {
        WebkitTextFillColor: grayColor[14],
        WebkitBoxShadow: `0 0 0 1000px ${fieldBg} inset`,
        borderRadius: 15,
      },
  },
  focused: {},
  whiteInput: {
    "&,&::placeholder": {
      color: whiteColor,
      opacity: "1",
    },
  },
  typography: {
    textTransform: "uppercase",
    textAlign: "left",
    color: "rgb(9, 64, 102)",
  },
};

export default customInputStyle;
